var _classCallCheck = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var _require2 = require('readable-stream'),
    PassThrough = _require2.PassThrough;

var eos = require('end-of-stream');

var path = require('path');

var render = require('render-media');

var streamToBlob = require('stream-to-blob');

var streamToBlobURL = require('stream-to-blob-url');

var streamToBuffer = require('stream-with-known-length-to-buffer');

var FileStream = require('./file-stream');

var queueMicrotask = require('queue-microtask');

var File = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(File, _EventEmitter);

  var _super = _createSuper(File);

  function File(torrent, file) {
    var _this;

    _classCallCheck(this, File);

    _this = _super.call(this);
    _this._torrent = torrent;
    _this._destroyed = false;
    _this.name = file.name;
    _this.path = file.path;
    _this.length = file.length;
    _this.offset = file.offset;
    _this.done = false;
    var start = file.offset;
    var end = start + file.length - 1;
    _this._startPiece = start / _this._torrent.pieceLength | 0;
    _this._endPiece = end / _this._torrent.pieceLength | 0;

    if (_this.length === 0) {
      _this.done = true;

      _this.emit('done');
    }

    return _this;
  }

  _createClass(File, [{
    key: "select",
    value: function select(priority) {
      if (this.length === 0) return;

      this._torrent.select(this._startPiece, this._endPiece, priority);
    }
  }, {
    key: "deselect",
    value: function deselect() {
      if (this.length === 0) return;

      this._torrent.deselect(this._startPiece, this._endPiece, false);
    }
  }, {
    key: "createReadStream",
    value: function createReadStream(opts) {
      var _this2 = this;

      if (this.length === 0) {
        var empty = new PassThrough();
        queueMicrotask(function () {
          empty.end();
        });
        return empty;
      }

      var fileStream = new FileStream(this, opts);

      this._torrent.select(fileStream._startPiece, fileStream._endPiece, true, function () {
        fileStream._notify();
      });

      eos(fileStream, function () {
        if (_this2._destroyed) return;

        if (!_this2._torrent.destroyed) {
          _this2._torrent.deselect(fileStream._startPiece, fileStream._endPiece, true);
        }
      });
      return fileStream;
    }
  }, {
    key: "getBuffer",
    value: function getBuffer(cb) {
      streamToBuffer(this.createReadStream(), this.length, cb);
    }
  }, {
    key: "getBlob",
    value: function getBlob(cb) {
      if (typeof window === 'undefined') throw new Error('browser-only method');
      streamToBlob(this.createReadStream(), this._getMimeType()).then(function (blob) {
        return cb(null, blob);
      }, function (err) {
        return cb(err);
      });
    }
  }, {
    key: "getBlobURL",
    value: function getBlobURL(cb) {
      if (typeof window === 'undefined') throw new Error('browser-only method');
      streamToBlobURL(this.createReadStream(), this._getMimeType()).then(function (blobUrl) {
        return cb(null, blobUrl);
      }, function (err) {
        return cb(err);
      });
    }
  }, {
    key: "appendTo",
    value: function appendTo(elem, opts, cb) {
      if (typeof window === 'undefined') throw new Error('browser-only method');
      render.append(this, elem, opts, cb);
    }
  }, {
    key: "renderTo",
    value: function renderTo(elem, opts, cb) {
      if (typeof window === 'undefined') throw new Error('browser-only method');
      render.render(this, elem, opts, cb);
    }
  }, {
    key: "_getMimeType",
    value: function _getMimeType() {
      return render.mime[path.extname(this.name).toLowerCase()];
    }
  }, {
    key: "_destroy",
    value: function _destroy() {
      this._destroyed = true;
      this._torrent = null;
    }
  }, {
    key: "downloaded",
    get: function get() {
      if (!this._torrent.bitfield) return 0;
      var _this$_torrent = this._torrent,
          pieces = _this$_torrent.pieces,
          bitfield = _this$_torrent.bitfield,
          pieceLength = _this$_torrent.pieceLength;
      var start = this._startPiece,
          end = this._endPiece;
      var piece = pieces[start]; // First piece may have an offset, e.g. irrelevant bytes from the end of
      // the previous file

      var irrelevantFirstPieceBytes = this.offset % pieceLength;
      var downloaded = bitfield.get(start) ? pieceLength - irrelevantFirstPieceBytes : Math.max(pieceLength - irrelevantFirstPieceBytes - piece.missing, 0);

      for (var index = start + 1; index <= end; ++index) {
        if (bitfield.get(index)) {
          // verified data
          downloaded += pieceLength;
        } else {
          // "in progress" data
          var _piece = pieces[index];
          downloaded += pieceLength - _piece.missing;
        }
      } // We don't know the end offset, so return this.length if it's oversized.
      // e.g. One small file can fit in the middle of a piece.


      return Math.min(downloaded, this.length);
    }
  }, {
    key: "progress",
    get: function get() {
      return this.length ? this.downloaded / this.length : 0;
    }
  }]);

  return File;
}(EventEmitter);

module.exports = File;